import type { ReactNode } from "react";

/**
 * A designed explanation, never a blank.
 *
 * The team Grafana org had no home dashboard, so six people's first impression
 * of the analytics stack was a screen that read "no access". An empty state
 * that does not say why reads as broken — so this component takes a `body` and
 * there is no way to render it without one.
 */
export function EmptyState({
  title,
  body,
  actions,
}: {
  title: string;
  body: string;
  actions?: readonly {
    label: string;
    href?: string;
    onClick?: () => void;
  }[];
}): ReactNode {
  return (
    <div className="empty">
      <div className="empty__title">{title}</div>
      <p className="empty__body">{body}</p>
      {actions === undefined || actions.length === 0 ? null : (
        <div className="empty__actions">
          {actions.map((action) =>
            action.href === undefined ? (
              <button
                key={action.label}
                type="button"
                className="button"
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ) : (
              <a
                key={action.label}
                className="button"
                href={action.href}
                target={action.href.startsWith("http") ? "_blank" : undefined}
                rel={action.href.startsWith("http") ? "noreferrer" : undefined}
              >
                {action.label}
              </a>
            ),
          )}
        </div>
      )}
    </div>
  );
}
